module.exports = __webpack_public_path__ + "static/media/55_000003.79a73066.jpg";